import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	DOC_SIGNED,
	DOC_SIGNING,
	DOC_SIGNING_FAILED,
	DOC_SIGNING_INITIALIZE,
} from "./types";
export const docSign = (listdata) => (dispatch) => {
	dispatch({ type: DOC_SIGNING });
	storeNotification.addNotification({
		title: "SigningDoc",
		message: "System is Signing Doc...",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});

	console.log("docSubmit data=", listdata);
	let formData = new FormData(); //formdata object

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: DOC_SIGNED, payload: response.data });
			storeNotification.addNotification({
				title: "Submit!",
				message: "Succefull Signed Doc",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Signing!",
				message: "failed to Sign Doc",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: DOC_SIGNING_FAILED,
				payload: error,
			});
		});
};

export const docSignInitialize = (listdata) => (dispatch) => {
	dispatch({ type: DOC_SIGNING_INITIALIZE });
};
